import { render, staticRenderFns } from "./AddLinkModal.vue?vue&type=template&id=3c056740&scoped=true&"
import script from "./AddLinkModal.vue?vue&type=script&lang=js&"
export * from "./AddLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c056740",
  null
  
)

export default component.exports